import React from 'react';
import { styled } from '@mui/material';
import { useIntl } from 'react-intl';
import { VisualizerMonthData } from '../../models';
import VisualizerMonthlyChart from './VisualizerMonthlyChart';

interface Props {
  month: VisualizerMonthData;
  maxWidth: number;
}

const ChartWrapper = styled('div')(({ theme }) => ({
  flexGrow: '1',
  height: '45px',
  // force override react-chartjs-2 auto width values
  '& canvas': {
    width: '100% !important',
  },
}));

const MonthLabel = styled('div')(({ theme }) => ({
  textTransform: 'uppercase',
  fontWeight: 'bold',
  fontSize: '14px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
  height: '19px',
  width: '27px',
}));

function VisualizerSummaryContainer({ month, maxWidth }: Props) {
  const intl = useIntl();
  return (
    <>
      <MonthLabel>{intl.formatMessage({ id: month.month.toLowerCase() }).substring(0, 3)}</MonthLabel>
      <ChartWrapper data-testid="visualizer-monthly-chart">
        <VisualizerMonthlyChart month={month} maxWidth={maxWidth} />
      </ChartWrapper>
    </>
  );
}

export { VisualizerSummaryContainer };
